<template>
  <div class="image">
    <van-image
      class="img"
      :src="handleUrl"
      :style="imageStyle"
    />
    <div class="desc">发货物料</div>
  </div>
</template>

<script>
import { MATERIAL_IMAGE_URL } from '@/utils/constant'

export default {
  name: 'MaterialImage',
  props: {
    materialTypeCode: {
      type: String,
      default: () => ''
    },
    url: {
      type: String,
      default: () => ''
    },
    imageStyle: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    handleUrl() {
      return this.url || MATERIAL_IMAGE_URL[this.materialTypeCode]
    }
  }
}
</script>
<style lang="scss" scoped>
.image {
  position: relative;
  width: 142px;
  height: 142px;
  border-radius: 12px;
  overflow: hidden;
  .img {}
  .desc {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background: rgba(27,27,27,0.5);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
}
</style>
